var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('TinyMCE',{staticStyle:{"padding":"0.5em","border":"1px solid","border-color":"#d8dbe0","border-radius":"0.25rem"},attrs:{"value":_vm.tmpValue},on:{"input":_vm.onValueChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }